export default {
  state: {
    glaNumbers: [],
    loading: false,
  },
  getters: {
    glaNumbers: state => state.glaNumbers,
    loading: state => state.loading,
  },
  mutations: {
    setGlaNumbers(state, glaNumbers) {
      state.glaNumbers = glaNumbers;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const glaNumbers = await axios.get('api/gla-numbers');
        commit('setGlaNumbers', glaNumbers);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/gla-numbers/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        await axios.post('api/gla-numbers', payLoad);
    },

    async update({ commit }, payLoad) {
        await axios.put('api/gla-numbers', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/gla-numbers/' + id);
    }
  },
};
